export default __webpack_public_path__ + "static/media/staffconnect.7596dd8a.svg";